export const ApiNames = {
    tv: 'tv',
    stories: 'stories',
    games: 'games',
}
export const AppNames = {
    tv: 'tv',
    stories: 'stories',
    games: 'games',
}
export const Events = {
    VIEW: 'VIEW',
    CLICK: 'CLICK',
    DOWNLOAD: 'DOWNLOAD',
    SEARCH: 'SEARCH',
    CLOSE: 'CLOSE',
    OPEN_APP: 'OPEN_APP',
    CLOSE_APP: 'CLOSE',
}
export const MediaTypes = {
    VIDEO: 'VIDEO',
    STORIES: 'STORIES',
    GAMES: 'GAMES',
    FOLDER: 'FOLDER',
    SOUND_CARD: 'SOUND_CARD',
}
export const Platform = {
    Android: 'Android',
    AndroidTV: 'AndroidTV',
    appleTv: 'appleTv',
    IOS: 'IOS',
    WEB: 'WEB',
}
export const DeviceType = {
    Tablet: 'Tablet',
    Web: 'WEB',
    Mobile: 'Mobile',
}
export const WatchUnits = {
    Minutes: 'minutes',
    Seconds: 'seconds',
}
  